import {IHttpProvider} from "angular";

/* @ngInject */
export const ieCacheFix = ($httpProvider: IHttpProvider) => {
    // Initialize http get header defaults if required
    if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
    }

    // Disable IE ajax request caching
    $httpProvider.defaults.headers.get["If-Modified-Since"] = 0;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/config/ie-cache-fix.config.ts